module.exports = __webpack_public_path__ + "static/media/distribuicao-3.d7989274.jpg";